"use client";
import { getLink } from "@frend-digital/storyblok";
import clsx from "clsx";
import React, { useCallback, useEffect } from "react";
import type { SnackbarStoryblok } from "@/generated/sb/sb-types";
import { Link } from "@/i18n/routing";
import usePersistedStore from "@/lib/stateManagement/persistedState/persistedStore";
import styles from "./Snackbar.module.css";

export const SnackbarBlok = ({ blok }: { blok: SnackbarStoryblok }) => {
  if (blok.link) {
    const href = getLink(blok.link)?.href;
    return (
      <Link className={styles.link} href={href || ""}>
        <SnackbarInner blok={blok} />
      </Link>
    );
  }

  return <SnackbarInner blok={blok} />;
};

const SnackbarInner = ({ blok }: { blok: SnackbarStoryblok }) => {
  const [_shouldShow, setShouldShow] = React.useState(false);
  const snackbar = usePersistedStore(state => state.snackbars);
  const addSnackbar = usePersistedStore(state => state.addSnackbar);

  const hasSeenSnackbar = snackbar.some(snackbar => snackbar.id === blok._uid);

  const _handleSnackbarClose = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      e.preventDefault();
      e.stopPropagation();
      addSnackbar({
        id: blok._uid,
        text: blok.primaryText ?? "",
      });
      setShouldShow(false);
    },
    [addSnackbar, blok],
  );

  useEffect(() => {
    if (!hasSeenSnackbar) {
      setShouldShow(true);
    } else {
      setShouldShow(false);
    }
  }, [snackbar, blok, hasSeenSnackbar]);

  /* force show
  if (!shouldShow) {
    return null;
  }
*/

  return (
    <div
      style={{
        backgroundColor: blok.backgroundColor ?? "#000000",
      }}
      className={clsx(styles.wrapper)}
    >
      {blok.primaryText}
      {/* force show
      <button className={styles.closeButton} onClick={handleSnackbarClose}>
        <CrossIcon />
      </button>
      */}
    </div>
  );
};
